/**
 * @desc: URL 查询参数初始化来源
 *
 * 从当前页面 URL 的查询参数中解析筛选器值。
 *
 * priority: 40（最高）
 */
import { isEmpty, isNotEmpty } from '@intelligence/v3/utils/common';
import { getFilterMiddlewareParams, normalizeFilterValueByItem } from '@intelligence/v3/filterControls/apiParams';
import { getFilterControlAdapter } from '@intelligence/v3/filterControls/controlAdapters';
import { getCurrentSearchParamsString } from '@intelligence/v3/utils/urlSearchParams';

import type { IFilterItemConfig, IFilterValues } from '@intelligence/v3/filterCore/types';
import type { IFilterInitSource } from '../types';

/**
 * 从 URL 查询参数反序列化筛选器值
 */
/**
 * 从当前 URL 中解析当前页面 items 管理的筛选值。
 * 每个控件通过自己的 middleware 声明 URL 字段和反序列化方式。
 */
const resolveUrlParams = (items: IFilterItemConfig[]): IFilterValues => {
  const result: IFilterValues = {};
  const searchParamsStr = getCurrentSearchParamsString();

  if (isEmpty(searchParamsStr)) {
    return result;
  }

  const searchParams = new URLSearchParams(searchParamsStr);

  items?.forEach((item) => {
    const controlAdapter = getFilterControlAdapter(item?.type);

    if (!controlAdapter) {
      console.debug('[useFilterablePage/urlParams] ' + `未找到类型 ${item?.type} 的 middlewareUtils`);
      return;
    }

    try {
      const middlewareParams = getFilterMiddlewareParams(item);
      const value = controlAdapter.middlewareUtils.deserializeUrlParams(item, searchParams, middlewareParams);
      if (isEmpty(value)) {
        return;
      }

      const normalizedValue = normalizeFilterValueByItem(item, value);
      if (isNotEmpty(normalizedValue)) {
        result[item.field] = normalizedValue as IFilterValues[string];
      }
    } catch (error) {
      console.debug('[useFilterablePage/urlParams] ' + `解析 ${item.field} 失败`, error);
    }
  });

  return result;
};

export const urlParamsSource: IFilterInitSource = {
  name: 'urlParams',
  priority: 40,
  resolve: async (items: IFilterItemConfig[]): Promise<IFilterValues> => {
    return resolveUrlParams(items);
  },
};
